import React from "react";
import './style.scss';
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import Button from "@material-ui/core/Button";
import CardContent from "@material-ui/core/CardContent";
import LogoImage from "../../../resources/images/ShipitLogo.png";
import TextField from "@material-ui/core/TextField";
import axios from "axios"
import BackgroundParticles from "../../Components/BackgroundParticles/BackgroundParticles";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import {isAuthenticated} from "../../Utils/Authentication";
import Direction from "../../Utils/Direction/Direction";
import {hotjar} from 'react-hotjar';

const ENTER_KEYCODE = 13;

export default class Login extends React.Component {
    constructor(props) {
        super(props);

        this.authFunctions = {
            phoneNumber: this.phoneVerification.bind(this),
            username: this.passwordVerification.bind(this),
        };

        this.state = {
            input: "",
            identifier: "",
            authType: "",
            errorMessage: "",
            didCheckforAlreadyAuthenticated: false
        }
    }

    componentWillMount() {
        this.checkAuthentication();
    }

    async checkAuthentication() {
        const authentication = await isAuthenticated();

        if (authentication.isAuthenticated) {
            this.loginSucceded(authentication.uid);
        } else {
            this.setState({
                didCheckforAlreadyAuthenticated: true
            })
        }
    }

    onChange(event) {
        this.setState({input: event.target.value})
    }

    openErrorMessage(errorMessage) {
        this.setState({
            input: "",
            errorMessage: errorMessage
        })
    }

    resetIdentifier() {
        this.setState({
            identifier: "",
            input: "",
            authType: "",
            errorMessage: ""
        })
    }

    async phoneVerification() {
        const {identifier, input} = this.state;
        const {data: verification} = await axios.post(`/api/v2/users/phoneVerification`, {
            phoneNumber: identifier,
            code: input
        });

        if (verification.verified)
            this.loginSucceded(verification.uid);
        else
            this.openErrorMessage("הקוד אינו נכון");
    }

    async passwordVerification() {
        const {identifier, input} = this.state;

        const {data: verification} = await axios.post(`/api/v2/users/passwordVerification`, {
            username: identifier,
            password: input
        });

        if (verification.verified)
            this.loginSucceded(verification.uid);
        else
            this.openErrorMessage("הסיסמא אינה נכונה");
    }

    loginSucceded(uid) {
        sessionStorage.setItem('uid', uid);
        hotjar.identify(uid, {});
        this.props.history.push('/ship');
    }

    async authenticateWithIdentifier() {
        const currentIdentifier = this.state.identifier || this.state.input;

        const {data: response} = await axios.get('/api/v2/users/identifierAuthentication', {
            params: {
                identifier: currentIdentifier
            }
        });

        if (response && response.success) {
            this.setState({
                identifier: currentIdentifier,
                input: "",
                authType: response.identifierType,
                errorMessage: ""
            });
        } else
            this.openErrorMessage("אין עובד עם מזהה זה")
    }

    loginUser() {
        if (!this.state.identifier)
            this.authenticateWithIdentifier();
        else
            this.getAuthFunction(this.state.authType)();
    }

    onKeyPressed(event) {
        const keyCode = event.keyCode ? event.keyCode : event.which;

        if (keyCode === ENTER_KEYCODE)
            this.loginUser();
    }

    getAuthFunction(authType) {
        const authFunction = this.authFunctions[authType];

        if (authFunction) return authFunction;

        return () => {
        };
    }

    getTextFieldLabel() {
        if (!this.state.identifier)
            return "הקלד שם משתמש או מספר טלפון";
        else if (this.state.authType === 'phoneNumber')
            return "הכנס קוד אימות";
        else if (this.state.authType === 'username')
            return "הכנס סיסמא";

        return '';
    }

    getTextFieldType() {
        if (this.state.authType === 'username')
            return "password";

        return "text";
    }

    render() {
        const {identifier, input, errorMessage, didCheckforAlreadyAuthenticated} = this.state;

        if (!didCheckforAlreadyAuthenticated)
            return (
                <div className="loading-container">
                    <CircularProgress size={80} thickness={2}/>
                </div>
            );

        return (
            <Direction direction="rtl">
                <div className="login-page">
                    <div className="login-container">
                        <Card className="card">
                            <div
                                className={`card-error ${!errorMessage ? "card-error-close" : ""}`}>{errorMessage}</div>
                            <CardContent>
                                <img className="card-image" src={LogoImage} alt="Shipit"/>
                                <TextField
                                    autoFocus={true}
                                    className="text-field"
                                    label={this.getTextFieldLabel()}
                                    value={input}
                                    type={this.getTextFieldType()}
                                    onChange={this.onChange.bind(this)}
                                    onKeyDown={this.onKeyPressed.bind(this)}
                                />
                            </CardContent>
                            <CardActions className="card-actions">
                                {!identifier ? null :
                                    <Button size="small" color="primary" onClick={this.resetIdentifier.bind(this)}>
                                        התחבר עם זהות אחרת
                                    </Button>
                                }
                                <Button size="small" color="primary"
                                        onClick={this.loginUser.bind(this)}
                                        variant="contained"
                                        className="login-button">
                                    התחבר
                                </Button>
                            </CardActions>
                        </Card>
                    </div>
                    <BackgroundParticles/>
                </div>
            </Direction>
        );
    }
}